import { MenuItem, Typography, ListItemText, useTheme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Icon } from 'packages/eid-icons'

const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: '160px',
        fontSize: '13px',
        position: 'relative',
        minHeight: '40px',
        height: '40px',
    },
    selected: {
        color: theme?.palette?.primary?.main,
        backgroundColor: `${theme?.palette?.primary?.light} !important`,
        borderLeft: `2px solid ${theme?.palette?.primary?.main}`,
        '& img': {
            opacity: 1,
            filter: 'grayscale(0%) ',
        },
    },
    sortLabelText: {
        color: '#aab0b4',
        fontSize: '12px',
        marginRight: '8px',
    },
}))

const SortingMenuItem = ({ displayName, selected, onClick, order }) => {
    const classes = useStyles()
    const theme = useTheme()

    return (
        <MenuItem onClick={onClick} classes={classes} selected={selected}>
            <ListItemText>{displayName}</ListItemText>

            {selected && (
                <>
                    <Typography className={classes.sortLabelText}>
                        {order === 'asc' ? 'A-Z' : 'Z-A'}
                    </Typography>

                    <Icon
                        name="ArrowLong"
                        width="16px"
                        height="16px"
                        color={theme?.palette?.primary?.main}
                        direction={order === 'asc' ? 'down' : 'up'}
                    />
                </>
            )}
        </MenuItem>
    )
}

export default SortingMenuItem
